<style scoped>
#login .right-layout {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-align-items: center;
  box-align: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  align-items: center;
}
#login .login-bg {
  padding: 35px 20px;
  height: 100%;
  /* height: calc(100vh * 0.5) !important; */
  min-height: 320px;
  max-height: 50vh;
  background: rgba(255, 255, 255, 0.3);
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -ms-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -khtml-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
}
#login .layout_pc {
  margin: 16px auto;
  max-width: 520px;
}
#login .q-panel.scroll {
  overflow: hidden !important;
}
#login .mobile_head {
  justify-content: space-between;
}
.login-footer:hover {
  color: #004271;
  cursor: pointer;
  text-decoration: underline #004271;
}
</style>
<template>
  <q-layout id="login" view="lHh lpr lFf">
    <q-header>
      <q-toolbar  elevated :class="['shadow-2', screenType ? 'q-px-xl' : 'mobile_head']"
        ><!--glossy  v-if="$i18n.locale=='zh'" -->
        <div :style="{ marginLeft: screenType ? '20px' : '0', height: screenType ? '42px' : '32px' }" style="padding: 0 5px; border-radius: 5px">
          <img ref="img" :src="'./img/logo.svg'" height="100%" style="object-fit:contain;" />
        </div>
        <q-toolbar-title style="font-size:25px;font-weight:bold;">{{ $t("title") }}</q-toolbar-title>
        <q-select v-model="lang" :options="$t('langs')" option-value="val" option-label="name" emit-value map-options borderless style="margin-right:20px;" :style="{ marginRight: screenType ? '20px' : '0' }">
          <template v-slot:prepend>
            <q-icon name="fa fa-globe fa-xs" class="text-white" />
          </template>
        </q-select>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <!-- <q-page class="absolute full-width q-pa-none" style="bottom:38px;">
    		<starSky style="height:calc(100vh - 88px)!important"></starSky>
    	</q-page> -->
      <q-page v-if="noDestroy" :class="['absolute', 'full-width', screenType ? 'q-pa-xl' : 'q-pa-md']" style="top:50px;bottom:38px;"
        ><!-- background:url(img/star.gif) repeat; -->
        <!-- <div ref="img" class="q-ma-md full-height flex" style="width:calc((100% - 4 * 16px) * 0.65)!important;float:left;">
    			<img ref="img" :src="'./img/banner.jpg'" width="100%" style="object-fit:contain;max-height:100%">
    		</div> -->
        <div :class="[screenType ? 'layout_pc' : '', 'full-height', 'flex', 'right-layout']" :style="{ width: screenType ? '45% !important' : '100%' }" >
          <div class="q-ma-lg full-width" style="background:rgba(0,0,0,.05);">
            <div class="full-width login-bg">
              <q-tabs v-model="loginType" active-color="primary" indicator-color="transparent" inline-label style="background:#fff;">
                <q-tab default name="1" :label="$t('login.account')" icon="fa fa-user fa-1x" />
                <!-- <q-tab name="2" :label="$t('login.sms')" icon="fa fa-mobile-alt fa-lg"/> -->
              </q-tabs>
              <q-tab-panels v-model="loginType" style="height:calc(100% - 48px);overflow:hidden;">
                <q-tab-panel name="1" class="q-px-lg fit" style="overflow:hidden;">
                  <q-input
                    ref="account"
                    v-model.trim="userName"
                    @keyup.enter="login(1)"
                    maxlength="20"
                    :placeholder="$t('login.user')"
                    dense
                    :rules="[(val) => !!val || $t('login.user'), (val) => (val.length <= 20 && val.length >= 4) || $t('login.msg1')]"
                    lazy-rules
                  />
                  <q-input
                    ref="pw"
                    v-model.trim="password"
                    @keyup.enter="login(1)"
                    maxlength="20"
                    type="password"
                    :placeholder="$t('login.password')"
                    no-pass-toggle
                    dense
                    :rules="[(val) => !!val || $t('login.password'), (val) => (val.length <= 20 && val.length >= 4) || $t('login.msg2')]"
                    lazy-rules
                  />
                  <!-- <q-chip v-if="error" color="red-7" text-color="white" icon="fa fa-exclamation-triangle fa-lg" style="padding-left:25px;width:100%;margin-top:10px;">{{$t('login.err1')}}</q-chip> -->
                  <ParticleEffect
                    ref="effect"
                    :hidden="effectHidden"
                    @begin="onBegin"
                    @complete="onComplete"
                    direction="top"
                    particle-type="rectangle"
                    particle-style="fill"
                    particle-color="#00897b"
                    :duration="500"
                    easing="easeOutQuad"
                    :canvas-padding="0"
                    :size="5"
                    :particlesAmountCoefficient="10"
                    style="width:100%;margin-top:15px;margin-bottom: 15px"
                  >
                    <q-btn @click="login(1)" :label="$t('login.btn')" :disable="disable" color="primary" class="full-width" style="font-size:16px;padding:0.5rem 0;"></q-btn>
                  </ParticleEffect>
                </q-tab-panel>
                <!-- <q-tab-panel name="2" class="q-px-lg fit scroll">
    								<q-input ref="phone" v-model.trim="phone" @keyup.enter="login(2)" maxlength="11" type="number" :placeholder="$t('login.phone')" dense
    									:rules="[val => !!val || '请输入手机号码', val => val.length==11 || '手机号码必须为11个字符']"/>
    								<q-input ref="code" v-model.trim="code" @keyup.enter="login(2)" maxlength="20" :placeholder="$t('login.code')" dense
    									:rules="[val => !!val || '请输入手机号码', val => val.length==11 || '手机号码必须为11个字符']">
    									<template v-slot:after><q-btn @click="smsCode()" icon="fa fa-arrow-circle-right fa-lg" color="primary" round dense>
    										<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('login.send')}}</q-tooltip>
    									</q-btn></template>
    								</q-input>
    								<q-chip v-if="error" color="red-7" text-color="white" icon="fa fa-exclamation-triangle fa-lg" style="padding-left:25px;width:100%;margin-top:10px;">{{$t('login.err2')}}</q-chip>
    								<ParticleEffect ref="effect" :hidden="effectHidden" @begin="onBegin" @complete="onComplete" direction="left"
    									particle-type="triangle" particle-style="fill" particle-color="#091388" :duration="800" :oscillationCoefficient="15"
    									:canvas-padding="0" :size="5" :particlesAmountCoefficient="4" style="width:100%;margin-top:15px;">
    									<q-btn @click="login(2)" :label="$t('login.btn')" color="primary" class="full-width" style="font-size:16px;padding:10px 0;"></q-btn>
    								</ParticleEffect>
    						</q-tab-panel> -->
              </q-tab-panels>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>

    <q-footer>
      <q-toolbar class="bg-white text-grey-7" style="height:38px;min-height:38px;">
        <q-toolbar-title style="text-align:center;font-size:14px;">
          <span v-if="this.$i18n.locale == 'zh'">DESIGNMAN 版权所有 © 2020&nbsp;&nbsp;</span>
          <span v-if="this.$i18n.locale == 'en'"> DESIGNMAN All Rights Reserved © 2020</span>
          <span v-if="this.$i18n.locale == 'ru'"> DESIGNMAN Все Лрава Защищены © 2020</span>
          <span class="login-footer" @click="copyright" v-if="this.$i18n.locale == 'zh'">{{ $t("copyright") }}</span>
          <span class="login-footer" @click="copyright1" v-if="this.$i18n.locale == 'zh'" :style="screenType ? '' : 'display:block;padding-bottom:10px'">
            <img style="padding: 0 5px;vertical-align: text-bottom;" :src="'./img/GongwangAnbei.png'" />粤公网安备 44060502002019号
          </span>
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>
<script>
import ParticleEffect from "./particle-effect";
//import starSky from './starSky';
import q_zh from "quasar/lang/zh-hans";
import q_en from "quasar/lang/en-us";
import q_ru from "quasar/lang/ru";
import SparkMD5 from "spark-md5";

export default {
  data() {
    return {
      w: "",
      h: "",
      root: GLOBAL_ROOT,
      bg: GLOBAL_ROOT + "web/images/banner.jpg",
      //lang_cmd:LANGS_CMD,
      lang: this.$t("langs")[0].val,
      loginType: "1",
      selected: 0,
      userName: null,
      password: null,
      disable: false,
      phone: null,
      code: null,
      error: false,
      effectHidden: false,
      noDestroy: true,
    };
  },
  components: {
    ParticleEffect,
    //starSky,
  },
  computed: {
    screenType() {
      return _isPC(); //this.$q.platform.is.desktop;
    },
  },
  created() {
    if (this.$i18n.locale == "zh") {
      this.lang = this.$t("langs")[0].val;
      this.$q.lang.set(q_zh);
    } else if (this.$i18n.locale == "en") {
      this.lang = this.$t("langs")[1].val;
      this.$q.lang.set(q_en);
    } else if (this.$i18n.locale == "ru") {
      this.lang = this.$t("langs")[2].val;
      this.$q.lang.set(q_ru);
    }
    var version = IEVersion(); //console.log(version);
    if (typeof version == "number" && version != -1 && version < 11) {
      this.$alert("提示：请使用 IE 11 以上的浏览器 或 其他类型浏览器！！", { showClose: false, showConfirmButton: false });
    }
  },
  mounted() {},
  watch: {
    lang(val, oldVal) {
      this.langChange(val);
    },
    loginType(val, oldVal) {
      this.error = false;
      this.effectHidden = false;
      if (this.$refs.effect) this.$refs.effect.onToggle();
      console.log(val);
    },
  },
  beforeDestroy() {
    this.noDestroy = false;
  },
  methods: {
    md5(str) {
      var spark = new SparkMD5();
      spark.append(str);
      var md5Str = spark.end();
      return md5Str;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    langChange(val) {
      var val2 = { zh: q_zh, en: q_en, ru: q_ru };
      localStorage.setItem("lang", val);
      this.$i18n.locale = localStorage.getItem("lang");
      this.$q.lang.set(val2[val]);
      window.document.title = this.$t("title");
      //this.lang = this.$t('langs')[index].val;
    },
    smsCode() {},
    login(type) {
      this.error = false;
      this.$refs.account.validate();
      this.$refs.pw.validate();
      if (this.$refs.account.hasError || this.$refs.pw.hasError) {
        this.accontError = false;
        return;
      }
      this.disable = true;
      var request = {};
      request.account = this.userName;
      request.password = this.md5(this.password);
      this.$ajax(0, "post", false, "/login", request)
        .then((res) => {
          this.effectHidden = true;
          var data = { id: res.data.userId, name: res.data.userName };
          //console.log(data)
          localStorage.setItem("AS_token", escape(res.data.authorization));
          localStorage.setItem("AS_name", escape(JSON.stringify(data)));
          setTimeout(() => {
            this.$router.push({ name: "main", params: data });
          }, 500);
        })
        .catch((err) => {
          this.disable = false;
          if (err.code) {
            this.error = true;
            var err_msg = this.$t("errMsg." + err.code) != "errMsg." + err.code ? this.$t("errMsg." + err.code) : this.$t("errMsg.default");
            this.$notify(2, err_msg, null);
          } else {
            this.$notify(2, this.$t("msg.request_err"), null);
          }
        });
    },
    onBegin() {
      //console.log('begin event')
    },
    onComplete() {
      //console.log('complete event')
    },
    copyright1() {
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060502002019", "_blank");
    },
    copyright() {
      window.open("http://www.beian.miit.gov.cn/", "_blank");
    },
  },
};
</script>
